export function statesStockToBuyers(listing: {
  intent?: string | null;
}): boolean {
  return listing.intent === "recycle";
}

export function isSourcedToOrder(listing: {
  intent?: string | null;
  checkoutEnabled?: boolean | null;
}): boolean {
  return !listing.checkoutEnabled && !statesStockToBuyers(listing);
}

export function lastStockCheckAt(listing: {
  stockCountedAt?: number;
  listingConfirmation?: { respondedAt?: number };
  publishedAt?: number;
  _creationTime: number;
}): number {
  return Math.max(
    listing.stockCountedAt ?? 0,
    listing.listingConfirmation?.respondedAt ?? 0,
    listing.publishedAt ?? listing._creationTime,
  );
}
